import { render } from "./SidebarNewsitems.vue?vue&type=template&id=07b428da&scoped=true"
import script from "./SidebarNewsitems.vue?vue&type=script&lang=js"
export * from "./SidebarNewsitems.vue?vue&type=script&lang=js"

import "./SidebarNewsitems.vue?vue&type=style&index=0&id=07b428da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b428da"]])

export default __exports__